import { PaymentPolicy } from "../objects/paymentPolicy";

export const EMPTY_PAYMENT_POLICY: PaymentPolicy = {
    agency: null,
    network: null,
    market: null,
    credit_line_enabled: false,
    credit_line: {
        amount_limit: null,
        currency: null,
        period: 'monthly',
        onetime_overflow_amount: null,
        onetime_overflow_is_percentage: false,
        onetime_overflow_enabled: false,
    },
    prepay_enabled: false,
    prepay_cb: false,
    prepay_bank_transfer: false,
    wallet_enabled: false,
    wallets: [],
    overflow_action: 'block',
    overflow_prepay_cb: false,
    overflow_prepay_bank_transfer: false,
    overflow_limit: null,
    overflow_is_percentage: false,
    notification_at_percentage: null,
    warranty_enabled: false,
    warranty_amount: null,
    warranty_currency: null,
};

export const EMPTY_PAYMENT_POLICY_WALLET_ITEM: PaymentPolicy['wallets'][0] = {
    amount: null,
    currency: null,
};